<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 14:36:23
 * @Description: 二级路由菜单
-->
<template>
	<div class="second-layout">
		<a-menu v-model="current" mode="horizontal">
			<a-menu-item v-for="item in getSecondMenus.children || []" :key="'/authserver/' + getSecondMenus.path + '/' + item.path">
				<router-link :to="'/authserver/' + getSecondMenus.path + '/' + item.path">
					<!-- <span>{{ item.meta.title }}</span> -->
					<span>{{ $t(`home.route_menus.${item.meta.field}`) }}</span>
				</router-link>
			</a-menu-item>
		</a-menu>
		<div style="margin-top: 35px">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
	name: "secondLayout",

	props: {
		// 父级路由对象
		getSecondMenus: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},

	data() {
		return {
			current: [this.$route.path],
		};
	},
	watch: {
		getSecondMenus: {
			immediate: true,
			handler: function(val) {
				console.log(221111,val)
				console.log("监听子菜单路由变化", val);
			},
		},
	},
	mounted(){
console.log(2222,this.$route,this.getSecondMenus)
	}
};
</script>

<style lang="less" scoped>
// 更改全局样式
.second-layout {
	::v-deep .ant-menu-item {
		border-radius: 10px 10px 0px 0px;
	}
	::v-deep .ant-menu-item-selected {
		border-bottom: 0;
		background-color: var(--primary-color);
		border-radius: 10px 10px 0px 0px;
		& > a {
			color: #fff;
		}
	}

	::v-deep .ant-menu-item:hover {
		border-bottom: 0;
		background-color: var(--primary-color);
		border-radius: 10px 10px 0px 0px;
		& > a {
			color: #fff;
		}
	}

	::v-deep .ant-menu-horizontal {
		border-bottom: 2px solid var(--primary-color);
	}
}
</style>
